// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Icon } from 'element-ui'
import animated from 'animate.css';

Vue.config.productionTip = false
Vue.use(Icon)
Vue.use(animated)

import './assets/css/common.css'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js